import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './GalleryAndTestimonials.css';

const GalleryAndTestimonials = () => {
  const galleryItems = [
    {
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYXOAxDDT1bRECAlftZiSHJndnlZSu7dBo_Q&s',
      caption: 'Custom Cardboard Boxes',
      alt: 'Custom Cardboard Boxes Showcase',
    },
    {
      image: 'https://lh3.googleusercontent.com/proxy/5l67LbZUP3N-q4UFmjRTvAJDjHYpRB5oKoJzhZMongmw5bE8fAzDB6IcL7RG5V-nuaEBxF1YdnMYQ3H4VO3fdRZjbdM-CEKNpY0U-_grX8qG_ZT2Gnr8mrdIbuk',
      caption: 'Printed Posters',
      alt: 'High-Quality Printed Posters',
    },
    {
      image: 'https://cdn.shopify.com/s/files/1/0225/4203/files/Green-Box-Open.jpg?2444',
      caption: 'Packaging Inserts',
      alt: 'Eco-Friendly Packaging Inserts',
    },
    {
      image: 'https://myprintsupplier.com/wp-content/uploads/2020/07/240_F_229446376_OLuIhMz5fxBypuU45CpkY4E2PjzXK9hY.jpg',
      caption: 'Branded Booklets',
      alt: 'Custom-Bound Booklets',
    },
  ];

  const testimonials = [
    {
      quote: 'NIRUPRINT SOLUTIONS delivered stunning custom boxes for our products. Exceptional quality and service!',
      author: 'Sarah Patel',
      role: 'E-commerce Owner, London',
    },
    {
      quote: 'Their printed posters brought our campaign to life. Fast delivery and vibrant colors!',
      author: 'James Carter',
      role: 'Marketing Manager, Slough',
    },
    {
      quote: 'The eco-friendly inserts from NIRUPRINT are perfect for our brand. Highly recommend!',
      author: 'Aisha Khan',
      role: 'Retailer, Birmingham',
    },
    {
      quote: 'Our branded booklets look professional thanks to NIRUPRINT. Great attention to detail!',
      author: 'Michael Lee',
      role: 'Business Consultant, Manchester',
    },
  ];

  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section id="gallery" className="gallery-testimonials">
      <div className="gallery-testimonials-container">
        <motion.div
          className="gallery-testimonials-content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: true }}
        >
          {/* Gallery Section */}
          <div className="gallery-section">
            <h2 className="gallery-heading">Our Work</h2>
            <p className="gallery-subheading">Explore our high-quality printing and binding projects.</p>
            <div className="gallery-grid">
              {galleryItems.map((item, index) => (
                <motion.div
                  key={index}
                  className="gallery-item"
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: index * 0.1, ease: 'easeOut' }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.05, boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)' }}
                >
                  <div className="gallery-image" style={{ backgroundImage: `url(${item.image})` }} />
                  <span className="gallery-caption">{item.caption}</span>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Testimonials Section */}
          <div className="testimonials-section">
            <h2 className="testimonials-heading">Client Testimonials</h2>
            <p className="testimonials-subheading">Hear from businesses who trust NIRUPRINT SOLUTIONS.</p>
            <div className="testimonials-carousel">
              <motion.div
                className="testimonial-item"
                key={currentTestimonial}
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5 }}
              >
                <p className="testimonial-quote">{testimonials[currentTestimonial].quote}</p>
                <p className="testimonial-author">{testimonials[currentTestimonial].author}</p>
                <p className="testimonial-role">{testimonials[currentTestimonial].role}</p>
              </motion.div>
              <div className="carousel-controls">
                <button
                  className="carousel-btn"
                  onClick={() =>
                    setCurrentTestimonial(
                      (prev) => (prev - 1 + testimonials.length) % testimonials.length
                    )
                  }
                >
                  ←
                </button>
                <div className="carousel-dots">
                  {testimonials.map((_, index) => (
                    <span
                      key={index}
                      className={`dot ${currentTestimonial === index ? 'active' : ''}`}
                      onClick={() => setCurrentTestimonial(index)}
                    />
                  ))}
                </div>
                <button
                  className="carousel-btn"
                  onClick={() => setCurrentTestimonial((prev) => (prev + 1) % testimonials.length)}
                >
                  →
                </button>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="gallery-testimonials-footer">
          <p>
            Contact NIRUPRINT SOLUTIONS for inquiries: <a href="mailto:nirupal92@gmail.com">nirupal92@gmail.com</a> |{' '}
            <a href="tel:+447304083286">07304 083286</a>
          </p>
          <p>UNIT H2C, Deseronto Estate, St. Mary Road, Slough, Berkshire, SL3 7EW</p>
        </div>
      </div>
    </section>
  );
};

export default GalleryAndTestimonials;